import React from "react";
import {
  Button,
  Typography,
  Badge,
  Alert,
  Divider,
  Checkbox,
  Modal,
} from "antd";
import "./modalStyles.css";
import { CloseOutlined, StarOutlined } from "@ant-design/icons";
import { addInlineStylesToTags } from "../../../pages/Admin-pages/CA-admin-pages/Communications/helper";
import { MAIN_LOGO_BIG } from "../../../ImagesSrc";

const { Title, Text } = Typography;

const NotificationsModal = ({
  visible,
  onClose,
  maintenanceNotifications = [],
  productNotifications = [],
  maintenanceLinks = {},
  productLinks = {},
  applications,
  dontShow,
  onDontShowChange,
}) => {
  const combinedNotifications = [
    ...(Array.isArray(maintenanceNotifications)
      ? maintenanceNotifications
      : []),
    ...(Array.isArray(productNotifications) ? productNotifications : []),
  ];

  const combinedLinks = {
    ...(maintenanceLinks && typeof maintenanceLinks === "object"
      ? maintenanceLinks
      : {}),
    ...(productLinks && typeof productLinks === "object" ? productLinks : {}),
  };

  console.log(productLinks, combinedLinks, "productLinks");
  const renderCustomPoints = (formData, links) => {
    return formData?.customPoints
      ?.filter((item) => item && item.point)
      .map((item, index) => {
        const link = links?.[index];
        const hasLink = link && link.name && link.url;
        return (
          <div key={index}>
            <Text className="text-loc-modal">
              <StarOutlined
                style={{ marginRight: "7.5px", fontSize: "12px" }}
              />
              {item?.point || ""}
              {hasLink && (
                <a
                  href={
                    link.url.startsWith("http")
                      ? link.url
                      : `https://${link.url}`
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {link.name}
                </a>
              )}
            </Text>
            {index !== formData.customPoints.length - 1 && (
              <Divider style={{ margin: "5px 0" }} />
            )}
          </div>
        );
      });
  };

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      width={800}
      centered
      className="notification-modal"
      maskClosable={false}
    >
      <div
        className="modal-content notifications-scroll"
        style={{ maxHeight: "600px", overflowY: "auto", padding: "5px" }}
      >
        {combinedNotifications.map((notification, index) => {
          const isProduct =
            notification?.sub_category === "Product Announcement";
          const matchedApplication =
            notification?.application === -1
              ? MAIN_LOGO_BIG
              : applications?.find(
                  (app) => app.id === notification?.application
                )?.logo || MAIN_LOGO_BIG;
          const BadgeStatus = isProduct
            ? "success"
            : notification?.priority === "High"
            ? "error"
            : "warning";
          const BadgeText = isProduct
            ? "New Announcement"
            : notification?.priority === "High"
            ? "High Priority"
            : "Low Priority";
          const alertBoxColor = isProduct ? "info" : "warning";

          return (
            <div key={index} className="notification-item">
              <div
                className="modal-title-container"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div>
                  <Badge
                    status={BadgeStatus}
                    text={BadgeText}
                    className="blinking-badge"
                    size="small"
                  />
                  <Title level={4} className="modal-title">
                    {notification?.title || "Enter Your Title"}
                  </Title>
                </div>
                <img
                  src={matchedApplication}
                  alt="App Logo"
                  className="app-logo"
                />
              </div>
              <Alert
                style={{ margin: "10px 0" }}
                description={
                  <>
                    {notification?.bullet_point ? (
                      renderCustomPoints(
                        notification,
                        combinedLinks[index] || []
                      )
                    ) : (
                      <div
                        dangerouslySetInnerHTML={{
                          __html: addInlineStylesToTags(
                            notification?.customhtml
                          ),
                        }}
                      />
                    )}
                  </>
                }
                type={alertBoxColor}
              />
              <Divider style={{ marginBottom: "15px", marginTop: "15px" }} />
            </div>
          );
        })}
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginInline: "25px",
        }}
      >
        <Text type="secondary">
          Need help? Contact{" "}
          <a href="mailto:support@example.com">support@trainery.one</a>
        </Text>
      </div>
      <div
        className="modal-footer"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: "5px",
        }}
      >
        <Checkbox onChange={onDontShowChange} checked={dontShow}>
          Don't show this again
        </Checkbox>
        <Button
          type="default"
          className="modal-btn close-btn"
          onClick={onClose}
          style={{ width: "25%" }}
        >
          <CloseOutlined /> Close
        </Button>
      </div>
    </Modal>
  );
};

export default NotificationsModal;
